import { type RouteRecordRaw } from "vue-router";
import { canAccess, haveOneAccess, permissionList } from "@/utilities/authorization";

const expenseRoutes: RouteRecordRaw[] = [
    {
        name: 'expense-navigation',
        path: '/expense/navigation',
        component: () => import('@/views/expense/ExpenseNavigation.vue'),
        beforeEnter: () => haveOneAccess([
            permissionList.READ_EXPENSE,
            permissionList.CREATE_EXPENSE,
            permissionList.PURCHASE_RAW_MATERIAL
        ]) ? true : { name: 'dashboard' },
    },
    {
        name: 'expense',
        path: '/expense',
        component: () => import('@/views/expense/ExpenseIndex.vue'),
        beforeEnter: () => canAccess(permissionList.READ_EXPENSE) ? true : { name: 'expense-navigation' },
    },
    {
        name: 'expense-new',
        path: '/expense/new',
        component: () => import('@/views/expense/NewExpense.vue'),
        beforeEnter: () => canAccess(permissionList.CREATE_EXPENSE) ? true : { name: 'expense-navigation' },
    },
    {
        name: 'expense-detail',
        path: '/expense/:id(\\d+)',
        component: () => import('@/views/expense/DetailExpense.vue'),
        beforeEnter: () => canAccess(permissionList.READ_EXPENSE) ? true : { name: 'expense-navigation' },
    },
    {
        name: 'expense-update',
        path: '/expense/update/:id(\\d+)',
        component: () => import('@/views/expense/UpdateExpense.vue'),
        beforeEnter: () => canAccess(permissionList.UPDATE_EXPENSE) ? true : { name: 'expense-navigation' },
    },
    {
        name: 'purchase-raw-material',
        path: '/expense/purchase-raw-material',
        component: () => import('@/views/expense/PurchaseRawMaterial.vue'),
        beforeEnter: () => canAccess(permissionList.PURCHASE_RAW_MATERIAL) ? true : { name: 'expense-navigation' },
    }
]

export default expenseRoutes
